import Network from 'infrastructure/js/modules/network';
import { api as messageDialogApi }  from '../../../MessageDialog/messageDialogActions.js';
import * as toolsService from '../../../../services/Tools/toolsService';
import * as operationsService from '../../../../services/Operations/operationsService';
import {createDialogActions} from '../../../Dialogs/CommonDialog/commonDialogActions';

export const {
  actionTypes,
  actions,
  api,
  jsxActions,
} = createDialogActions({

  config: {
    getSubmitMethod: ({isEditMode}) =>
      isEditMode  ? toolsService.editToolCategory : toolsService.createToolCategory,
  },

  apiOverrides: {
    fetchDialogData(dispatch, getState) {
      return function() {
        return operationsService.fetchAllOperations().then((response) => {
          if (!Network.isResponseValid(response)) {
            console.error('Fetching Operations failed', response);
            messageDialogApi.responseError(dispatch, getState)(response);
            return {success: false};
          }

          let dialogData = {
            operations: response.dataList.map((obj) => {return {value: obj.id, label: obj.displayName, data: obj}}),
          };

          dispatch(actions.fetchDialogDataReady(dialogData));
          return {success: true};
        });
      }
    },
  },

});

// const config = {
//   getSubmitMethod: (submitConfigData) => {
//     return submitConfigData && submitConfigData.isEditMode ?
//       toolsService.editToolCategory : toolsService.createToolCategory;
//   }
// };
//
// export const actionTypes = {
//   ...daHelper.getActionTypes(dialogsNames.CREATE_TOOL_CATEGORY_DIALOG),
// };
//
// const actions = {
//   ...daHelper.getActions(dialogsNames.CREATE_TOOL_CATEGORY_DIALOG),
// };
//
// export let api = {
//   ...daHelper.getApiActions(actions, config),
//
//   fetchDialogData(dispatch, getState) {
//     return function() {
//       return operationsService.fetchAllOperations().then((response) => {
//         if (!Network.isResponseValid(response)) {
//           console.error('Fetch Operation Types', response);
//           messageDialogApi.responseError(dispatch, getState)(response);
//           return {success: false};
//         }
//
//         let dialogData = {
//           operations: response.dataList.map((obj) => {return {value: obj.id, label: obj.displayName, data: obj}}),
//         };
//
//         dispatch(actions.fetchDialogDataReady(dialogData));
//         return {success: true};
//       });
//     }
//   }
// };
//
// export let jsxActions = {
//   ...daHelper.getJsxActions(api),
// };

